const DEFAULT_CHAT_TITLES = new Set([
    '',
    'new agent run',
    'new ai chat',
    'new chat',
    'new internal chat',
    'untitled conversation',
]);

export function isDefaultChatTitle(title: string | null | undefined): boolean {
    return DEFAULT_CHAT_TITLES.has((title ?? '').trim().toLowerCase());
}

export function visibleChatTitle(
    ...titles: Array<string | null | undefined>
): string {
    for (const title of titles) {
        if (title && !isDefaultChatTitle(title)) {
            return title;
        }
    }
    for (const title of titles) {
        const trimmed = title?.trim();
        if (trimmed) {
            return trimmed;
        }
    }
    return 'New chat';
}
